import {
  Image,
  SimpleModal,
  TextInputField,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { FC } from 'react'
import {
  BorderRadius6,
  GreyGrey10,
  GreyGrey70,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'
import { useLinkSalesforceOpportunityModal } from './useLinkSalesforceOpportunityModal'
import Spinner from 'components/Loading/Spinner'
import salesforceOpportunityIcon from './salesforceOpportunityIcon.svg'

export const LinkSalesforceOpportunityModal: FC<{
  onLink: (args: { opportunityId: string }) => void
  onClose: () => void
}> = props => {
  const hook = useLinkSalesforceOpportunityModal({
    onConfirm: props.onLink
  })

  return (
    <SimpleModal
      isOpen
      onClose={props.onClose}
      data-testid="salesforce.opportunity.link.modal"
      title="Link quote to a Salesforce opportunity"
      submitButtonText="Create link"
      cancelButtonText="Cancel"
      submitDisabled={hook.submit.disabled}
      onSubmit={hook.submit.onClick}
      minHeight="0px"
    >
      <Flex
        color={GreyGrey80}
        {...Primary13Regular}
        flexDirection="column"
        gap="16px"
      >
        <TextInputField
          value={hook.fields.linkToAccount.value}
          onChange={e => hook.fields.linkToAccount.onChange(e.target.value)}
          label="Opportunity ID or URL"
          data-testid="linkToAccount"
          validationErrors={hook.fields.linkToAccount.validationErrors}
          placeholder="Enter an opportunity ID or URL"
        />

        {hook.externalAccountDetails.show && (
          <Grid
            gridTemplateColumns="auto 1fr auto"
            gridColumnGap="8px"
            backgroundColor={GreyGrey10}
            borderRadius={BorderRadius6}
            padding="12px"
            alignItems="center"
          >
            {hook.externalAccountDetails.name && (
              <>
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  height="20px"
                  width="20px"
                  borderRadius="1.667px"
                  backgroundColor="#FF5D2D"
                >
                  <Image
                    src={salesforceOpportunityIcon}
                    height="16px"
                    width="16px"
                  />
                </Flex>
                <GridItem
                  {...Primary13SemiBold}
                  color={GreyGrey70}
                  data-testid="salesforce.opportunity.link.modal.externalName"
                >
                  {hook.externalAccountDetails.name}
                </GridItem>
              </>
            )}
            {hook.externalAccountDetails.fetching && (
              <GridItem
                {...Primary13SemiBold}
                color={GreyGrey70}
                display="flex"
                gap="8px"
              >
                <Spinner height="16px" width="16px" color={GreyGrey70} />{' '}
                Fetching opportunity information...
              </GridItem>
            )}
          </Grid>
        )}
      </Flex>
    </SimpleModal>
  )
}
